import React from "react";
import { Button, Modal } from "react-bootstrap";

const SuccessPopUp = (props: any) => {
  return (
    <div>
      <Modal
        show={props.showSuccessModal}
        onHide={props.handleCloseSuccessModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Message envoyé</Modal.Title>
        </Modal.Header>
        <Modal.Body>Votre message a bien été envoyé. Nous vous répondrons dans les meilleurs délais.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={props.handleCloseSuccessModal}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SuccessPopUp;
